module.exports = __webpack_public_path__ + "img/ticktock_ikona.17495952.svg";